import { render, staticRenderFns } from "./InstagramStory.vue?vue&type=template&id=5455afad&"
import script from "./InstagramStory.vue?vue&type=script&lang=js&"
export * from "./InstagramStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports